import { render } from "./klaviyo.vue?vue&type=template&id=4789917e"
import script from "./klaviyo.vue?vue&type=script&lang=js"
export * from "./klaviyo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__